import React, { useEffect, useRef } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet.migration';

import camionImg from '../images/camion.png'; // Import the image

const MigrationMap = () => {
  const mapRef = useRef(null);

  useEffect(() => {
    const map = L.map(mapRef.current).setView([45.69310279173019, 5.6311014376132045], 5);

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    }).addTo(map);

    const data = [
      {
        labels: ['ATV Logistics', ''],
        from: [5.6311014376132045, 50.69310279173019],
        to: [2.3522249414761247, 48.85664957331261],
        color: '',
        value: '',
      },
      {
        labels: ['', ''],
        from: [5.6311014376132045, 50.69310279173019],
        to: [1, 40],
        color: '',
        value: '',
      },
      {
        labels: ['', ''],
        from: [5.6311014376132045, 50.69310279173019],
        to: [4.357549432224214, 50.84461576564851],
        color: '',
        value: '',
      },
      // Add more migration data as needed
    ];

    const popover = L.DomUtil.create('div', 'popover');
    const options = {
      marker: {
        radius: [5, 5],
        pulse: true,
        textVisible: false,
      },
      line: {
        width: 1,
        order: false,
        icon: {
          type: 'arrow',
          size: 10,
        },
      },
      replacePopover(x, y, data, index) {
        popover.innerHTML =
          'value:' + data.value + '\nfrom:' + data.labels[1] + '\nto:' + data.labels[0];
        return popover;
      },
      onShowPopover(data, index) {
        console.log(data, index, 'show popover');
      },
      onHidePopover(data) {
        console.log('hide popover', data);
      },
    };

    const migrationLayer = L.migrationLayer(data, options).addTo(map);
    migrationLayer.setStyle({ pulse: { radius: 20 } });

    const customIcon = L.divIcon({
        className: 'custom-div-icon',
        html: `<img src="${camionImg}" style="width: 40px; height: 40px; transform: translate(-15px, 5px);" />`,
    });

    // data.forEach((item) => {
    //     const fromMarker = L.marker([item.to[1], item.to[0]], { icon: customIcon }).addTo(map);
    //     const toMarker = L.marker([item.from[1], item.from[0]], { icon: customIcon }).addTo(map);
    // });


    // Cleanup function
    return () => {
      map.remove();
    };
  }, []);

  return <div ref={mapRef} style={{ width: "50vw", height: '600px' }} />;
};

export default MigrationMap;
